/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseMessage } from '../../models/api-response-message';
import { CreateMessage } from '../../models/create-message';

export interface CreateMessage$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body?: {
'createMessage': CreateMessage;
'mediaList'?: Array<Blob>;
}
}

export function createMessage(http: HttpClient, rootUrl: string, params: CreateMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseMessage>> {
  const rb = new RequestBuilder(rootUrl, createMessage.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseMessage>;
    })
  );
}

createMessage.PATH = '/v1/api/ui/message';
